import { Button, Form, Image, Modal } from "react-bootstrap";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "../dadosalunos/DadosAlunos.module.css";
import usuario from "../../assets/image.png";
import { useEffect, useState } from "react";
import { HiOutlineDocumentReport, HiOutlineDocumentText } from "react-icons/hi";
import { TiLocationOutline } from "react-icons/ti";
import { BsTelephone } from "react-icons/bs";
import { GoPeople } from "react-icons/go";
import { GrMapLocation, GrMap } from "react-icons/gr";
import { BsCalendar2Date } from "react-icons/bs";
import { LuBuilding, LuHouse, LuMapPinHouse } from "react-icons/lu";
import { IoPersonOutline } from "react-icons/io5";
import { MdEdit, MdDelete, MdOutlineEmail, MdOutlineNumbers } from "react-icons/md";
import DadosAlunosAPI from "../../services/DadosAlunosApi";
import InputMask from "react-input-mask";
import Alerta from "../../components/alerta/Alerta";
import debounce from "lodash.debounce";
import FotosApi from "../../services/FotosApi";
import image from "../../assets/image.png";
import Loader from "../../components/loader/Loader";
import InputBuscar from "../../components/inputBuscar/InputBuscar";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";



function DadosAlunos() {
  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);
  const [foto, setFoto] = useState(null);
  const [email, setEmail] = useState("");
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false);
  const [mostrarModalImagem, setMostrarModalImagem] = useState(false);
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");
  const [senhaAtual, setSenhaAtual] = useState("");
  const [senhaNova, setSenhaNova] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");

  const [modalEdicao, setEdicao] = useState(false);

  const [dadosUsuario, setDadosUsuario] = useState({
    bairroUsuarioEnderecos: "",
    cepEnderecos: "",
    cidadeEnderecos: "",
    complementoEnderecos: "",
    email: "",
    nomeCompletoPessoa: "",
    nomeContatoPessoa: "",
    cpfPessoa: "",
    rgPessoa: "",
    dataNascimentoPessoa: "",
    ufEnderecos: "",
    logradouroEnderecos: "",
    numeroEnderecos: "",
    numeroTelefone: "",
  });

  const [loading, setLoading] = useState(false);



  async function buscarCEP(cep) {
    try {
      cep = cep.replace(/\D/g, "");

      if (cep.length !== 8) return;

      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);

      const data = await response.json();

      if (data.erro) {
        setMensagemAlerta("CEP não encontrado. Verifique e tente novamente.");
        setTipoAlerta("danger");
        exibirAlerta(true);
      }

      setDadosUsuario((prevState) => ({
        ...prevState,
        cepEnderecos: data.cep,
        logradouroEnderecos: data.logradouro,
        bairroUsuarioEnderecos: data.bairro,
        cidadeEnderecos: data.localidade,
        ufEnderecos: data.uf,

      }));
    } catch (error) {
      console.error("Erro ao buscar CEP:", error);
      exibirAlerta("Erro ao buscar CEP. Tente novamente mais tarde.", "danger");
    }
  }

  const buscarCEPDebounced = debounce((cep) => buscarCEP(cep), 500);

  const exibirAlerta = () => {
    setMostrarAlerta(true);
    setTimeout(() => {
      setMostrarAlerta(false);
    }, 3000);
  };

  // ja pega o id do usuario automatico
  async function CarregarDados() {

    const dados = await DadosAlunosAPI.ObterInformacoesProcedure();

    const data = new Date(dados.dataNascimentoPessoa);


    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();

    dados.dataNascimentoPessoa = `${dia}/${mes}/${ano}`;

    if (dados) {
      setDadosUsuario(dados);
    }
  }

  const AtualizarPerfil = async () => {
    try {
      setLoading(true);
      if (!dadosUsuario.nomeCompletoPessoa) {
        setMensagemAlerta("Nome completo é obrigatório.");
        setTipoAlerta("danger");
        exibirAlerta(true);
        return;
      }

      if (!dadosUsuario.nomeContatoPessoa) {
        setMensagemAlerta("Nome do contato é obrigatório.");
        setTipoAlerta("danger");
        exibirAlerta(true);
        return;
      }

      if (
        !dadosUsuario.numeroTelefone ||
        !validarTelefone(dadosUsuario.numeroTelefone)
      ) {
        setMensagemAlerta("Telefone inválido.");
        setTipoAlerta("danger");
        exibirAlerta(true);
        return;
      }
      const dataNascimento = dadosUsuario.dataNascimentoPessoa;

      const [dia, mes, ano] = dataNascimento.split("/");
      const dataNascimentoFormatada = `${ano}-${mes}-${dia}`;

      const dadosAtualizados = {
        usuarioAtualizarPrimeiroLogin: {
          nomeCompleto: dadosUsuario.nomeCompletoPessoa,
        },
        atualizarPessoaPerfil: {
          nomeCompleto: dadosUsuario.nomeCompletoPessoa,
          nomeContato: dadosUsuario.nomeContatoPessoa,
          cpf: dadosUsuario.cpfPessoa,
          rg: dadosUsuario.rgPessoa,
          dataDeNascimento: dataNascimentoFormatada,
        },
        atualizarEnderecoPerfil: {
          id: dadosUsuario.enderecoID,
          bairro: dadosUsuario.bairroUsuarioEnderecos,
          logradouro: dadosUsuario.logradouroEnderecos,
          numero: dadosUsuario.numeroEnderecos,
          cep: dadosUsuario.cepEnderecos,
          cidade: dadosUsuario.cidadeEnderecos,
          uf: dadosUsuario.ufEnderecos,
          complementoEnderecos: dadosUsuario.complementoEnderecos,
        },
        atualizarTelefonePerfil: {
          numero: dadosUsuario.numeroTelefone,
          telefoneID: dadosUsuario.telefoneID,
        },
      };

      await DadosAlunosAPI.EditarTabelaPessoa(dadosAtualizados);

      CarregarDados();

      setMensagemAlerta(`Usuário atualizado com sucesso!`);
      setTipoAlerta("success");
      exibirAlerta(true);
    } catch (error) {
      console.error("Erro ao atualizar usuário:", error);
      setMensagemAlerta(
        `Erro ao atualizar usuário: ${error.response?.data || "Erro desconhecido"
        }`
      );
      setTipoAlerta("danger");
      exibirAlerta(true);
    } finally {
      setLoading(false);
    }
  };

 

  function validarTelefone(telefone) {
    const telefoneLimpo = telefone.replace(/[^\d]/g, "");
    const regexTelefone = /^\d{11}$/;
    return regexTelefone.test(telefoneLimpo);
  }

  async function AlterarSenhaUsuario() {
    try {
      setLoading(true);
      if (!senhaAtual || !senhaNova || !confirmarSenha) {
        setMensagemAlerta("Todos os campos são obrigatórios.");
        setTipoAlerta("danger");
        exibirAlerta();
        return;
      }

      const validacao =
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (!validacao.test(senhaNova)) {
        setMensagemAlerta(
          "A senha deve ter no mínimo 8 caracteres, uma letra maiúscula, um número e um caractere especial."
        );
        setTipoAlerta("danger");
        exibirAlerta();
        return;
      }

      if (senhaNova !== confirmarSenha) {
        setMensagemAlerta("As senhas novas não coincidem.");
        setTipoAlerta("danger");
        exibirAlerta();
        return;
      }

      await DadosAlunosAPI.AlterarSenhaPerfilUsuario(
        senhaAtual,
        senhaNova,
        confirmarSenha
      );

      setMensagemAlerta("Senha alterada com sucesso!");
      setTipoAlerta("success");
      exibirAlerta();
      setSenhaAtual("");
      setSenhaNova("");
      setConfirmarSenha("");
    } catch (error) {
      setMensagemAlerta("Erro inesperado ao alterar senha.");
      setTipoAlerta("danger");
      exibirAlerta();
    } finally {
      setMostrarModalEditar(false);
      setLoading(false);
    }
  }

  const FecharModal = () => {
    setMostrarModalEditar(false);
    setMostrarModalImagem(false)
  };


  async function DeletarFotoUsuario() {
    try {
      setLoading(true);
      await FotosApi.DeletarFoto();

      setFoto(null);
      localStorage.removeItem("fotoUsuario");
      window.dispatchEvent(new CustomEvent("fotoAtualizada", { detail: null }));

      setMensagemAlerta("Foto do perfil excluída com sucesso!");
      setTipoAlerta("success");
      FecharModal()
    } catch (error) {
      console.error("Erro ao deletar foto:", error);
      setMensagemAlerta(`Erro ao excluir o perfil: ${error.response?.data || "Erro desconhecido"}`);
      setTipoAlerta("danger");
    } finally {
      setLoading(false);
    }
  }

  async function ObterFoto() {
    try {
      const blob = await FotosApi.ObterFoto()

      if (blob && blob.size > 0) {
        setFoto(URL.createObjectURL(blob));
          
      } 
    } catch (error) {
      setMensagemAlerta(`Erro ao atualizar o perfil ${error}`);
      setTipoAlerta("danger");
    }
  }

  async function atualizarFoto(e) {

    const foto = e.target.files[0];
    if (!foto) return;

    const formData = new FormData();
    formData.append("fotoPerfil", foto);



    try {
      setLoading(true);
      await FotosApi.SalvarFoto(formData);

      setFoto(null);
      ObterFoto();
      const blobb = await FotosApi.ObterFoto();

      const fotoUrl = URL.createObjectURL(blobb);
      localStorage.setItem("fotoUsuario", fotoUrl);

      window.dispatchEvent(new CustomEvent("fotoAtualizada", { detail: fotoUrl }));

      setMensagemAlerta("Foto de perfil atualizada com sucesso!");
      setTipoAlerta("success");
      FecharModal()

    } catch (error) {
      let mensagemErro = "Erro ao atualizar a foto.";

      if (error.response) {
        if (error.response.status === 400) {
          mensagemErro = error.response.data;
        } else if (error.response.status === 500) {
          mensagemErro = "Erro interno no servidor.";
        }
      }

      setMensagemAlerta(mensagemErro);
      setTipoAlerta("danger");
    } finally {
      setLoading(false);
      exibirAlerta();
    }
  }

  useEffect(() => {
    ObterFoto();
    CarregarDados();

  }, []);
  return (
 <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
      <Topbar
        menuHamburguerAberto={menuHamburguerAberto}
        setMenuHamburguerAberto={setMenuHamburguerAberto}
      >
        <Alerta
          tipo={tipoAlerta}
          mensagem={mensagemAlerta}
          visivel={mostrarAlerta}
          aoFechar={() => setMostrarAlerta(false)}
        />
        {loading && <Loader />}
        <div className={style.pagina_conteudo}>
          {/* <MdEdit size={20} /> */}

          <div className={style.fundoImagem}>
            <div className={style.imagem_container}>
              <Image src={foto || usuario}
                alt="Usuário"
                className={style.imgUsuario}
                onClick={() => setMostrarModalImagem(true)}

              />

              {/* Imagem de edição que só aparece no hover
              <Image
                src={image} // coloque aqui a imagem de "editar"
                alt="Editar"
                onClick={() => setMostrarModalImagem(true)}
                className={`${style.imgUsuario} ${style.fotoEditar}`}
              /> */}

              {/* Input upload */}
              <input
                type="file"
                accept="image/*"
                id="fileInput"
                onChange={atualizarFoto}
                className={style.inputFile}
              />

            </div>
            <div className={style.perfil_usuario}>

              <h1 className={style.fonte1}>{dadosUsuario.nomeContatoPessoa.length > 40 ? `${dadosUsuario.nomeContatoPessoa.substring(0, 40)}...` : dadosUsuario.nomeContatoPessoa} </h1>
              <h1 className={style.fonte2}>{dadosUsuario.email}</h1>
            </div>
          </div>


          <div className={style.fundo_infomarcoes}>

            <div className={style.topo}>
              <label className={style.texto_pessoais}>Informações Pessoais</label>
            </div>

            <div className={style.informacoes_pessoais}>
              {/* Nome */}
              <div className={style.informacoes}>
                <div className={style.nome}>

                  <div >
                    <IoPersonOutline className={style.icon} />
                  </div>

                  <div className={style.input_dados}>
                    <label className={style.label}>  Nome
                    </label>
                    <input
                      maxLength={100}
                      type="text"
                      value={dadosUsuario.nomeCompletoPessoa}
                      disabled={!modalEdicao}

                      onChange={(e) =>
                        setDadosUsuario({ ...dadosUsuario, nomeCompletoPessoa: e.target.value })
                      }
                      className={`${style.inputLikeText} ${modalEdicao ? style.inputHabilitado : ''}`}
                    />
                  </div>
                </div>

                {/* Nome Contato */}

                <div className={style.nome}>
                  <div>
                    <GoPeople />
                  </div>

                  <div className={style.input_dados}>
                    <label className={style.label}>Nome Contato</label>
                    <input
                      maxLength={100}
                      type="text"
                      value={dadosUsuario.nomeContatoPessoa}
                      disabled={!modalEdicao}
                      onChange={(e) =>
                        setDadosUsuario({ ...dadosUsuario, nomeContatoPessoa: e.target.value })
                      }
                      className={`${style.inputLikeText} ${modalEdicao ? style.inputHabilitado : ''}`}
                    />
                  </div>
                </div>

                {/* Telefone */}
                <div className={style.nome}>
                  <div>
                    <BsTelephone />
                  </div>

                  <div className={style.input_dados}>

                    <label className={style.label}>Telefone</label>
                    <InputMask
                      mask="(99) 99999-9999"
                      value={dadosUsuario.numeroTelefone}
                      disabled={!modalEdicao}
                      className={`${style.inputLikeText} ${modalEdicao ? style.inputHabilitado : ''}`}
                      onChange={(e) =>
                        setDadosUsuario({ ...dadosUsuario, numeroTelefone: e.target.value })
                      }
                    >
                      {(inputProps) => (
                        <input
                          {...inputProps}
                          type="text"
                          className={`${style.inputLikeText} ${modalEdicao ? style.inputHabilitado : ''}`}
                          placeholder="(00) 00000-0000"
                          disabled={!modalEdicao}

                        />
                      )}
                    </InputMask>
                  </div>
                </div>


                {/* Data de Nascimento */}
                <div className={style.nome}>
                  <div>
                    <BsCalendar2Date />
                  </div>
                  <div className={style.input_dados}>
                    <label className={style.label}>Data de Nascimento</label>
                    <InputMask
                      mask="99/99/9999"
                      value={dadosUsuario.dataNascimentoPessoa}
                      className={`${style.inputLikeText} ${modalEdicao ? style.inputHabilitado : ''}`}
                      disabled={!modalEdicao}
                      onChange={(e) =>
                        setDadosUsuario({
                          ...dadosUsuario,
                          dataNascimentoPessoa: e.target.value,
                        })
                      }
                    >
                      {(inputProps) => (
                        <input
                          {...inputProps}
                          type="text"
                          className={`${style.inputLikeText} ${modalEdicao ? style.inputHabilitado : ''}`}
                          placeholder="DD/MM/AAAA"
                          disabled={!modalEdicao}
                        />
                      )}
                    </InputMask>
                  </div>
                </div>
              </div>
              <div className={style.informacoes}>
                {/* RG */}
                <div className={style.nome}>

                  <div>
                    <HiOutlineDocumentReport />
                  </div>
                  <div className={style.input_dados}>
                    <label className={style.label}>RG</label>
                    <InputMask
                      mask="99.999.999"
                      value={dadosUsuario.rgPessoa}
                      className={`${style.inputLikeText} ${modalEdicao ? style.inputHabilitado : ''}`}
                      disabled
                      readOnly
                      onChange={(e) =>
                        setDadosUsuario({ ...dadosUsuario, rgPessoa: e.target.value })
                      }
                    >
                      {(inputProps) => (
                        <input
                          {...inputProps}
                          type="text"
                          className={style.inputLikeText}
                          placeholder="RG"
                          disabled
                          readOnly
                        />
                      )}
                    </InputMask>
                  </div>

                </div>
                <div className={style.nome}>

                  <div>
                    <MdOutlineEmail />
                  </div>
                  <div className={style.input_dados}>
                    <label className={style.label}>Email</label>
                    <input
                      type="text"
                      value={dadosUsuario.email}
                      disabled
                      readOnly
                      className={style.inputLikeText}
                    />

                  </div>

                </div>

                {/* CPF (somente leitura) */}
                <div className={style.nome}>

                  <div>
                    <HiOutlineDocumentText />
                  </div>

                  <div className={style.input_dados}>
                    <label className={style.label}>CPF</label>
                    <InputMask
                      mask="999.999.999-99"
                      value={dadosUsuario.cpfPessoa}
                      className={`${style.inputLikeText} ${modalEdicao ? style.inputHabilitado : ''}`}
                      disabled
                      readOnly
                      onChange={(e) =>
                        setDadosUsuario({ ...dadosUsuario, cpfPessoa: e.target.value })
                      }
                    >
                      {(inputProps) => (
                        <input
                          {...inputProps}
                          type="text"
                          className={style.inputLikeText}
                          placeholder="CPF"
                          disabled
                          readOnly
                        />
                      )}
                    </InputMask>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className={style.fundo_infomarcoes}>

            <div className={style.topo}>
              <label className={style.texto_pessoais}>Endereço</label>
            </div>



            {/* Endereço */}
            <div className={style.informacoes_pessoais}>
              <div className={style.informacoes}>


                {/* CEP  */}
                <div className={style.nome}>
                  <div>
                    <GrMap />
                  </div>
                  <div className={style.input_dados}>
                    <label className={style.label}>CEP</label>
                    <InputMask
                      mask="99999-999"
                      value={dadosUsuario.cepEnderecos}
                      className={`${style.inputLikeText} ${modalEdicao ? style.inputHabilitado : ''}`}
                      disabled={!modalEdicao}
                      onChange={(e) => {
                        const valor = e.target.value;
                        setDadosUsuario({
                          ...dadosUsuario,
                          cepEnderecos: valor,

                        });

                        buscarCEPDebounced(valor);
                      }}
                    >
                      {(inputProps) => (
                        <input
                          {...inputProps}
                          type="text"
                          placeholder="Digite o CEP"
                          className={`${style.inputLikeText} ${modalEdicao ? style.inputHabilitado : ''}`}
                          disabled={!modalEdicao}
                        />
                      )}
                    </InputMask>
                  </div>
                </div>

                <div className={style.nome}>
                  <div >
                    <TiLocationOutline />
                  </div>

                  <div className={style.input_dados}>
                    <label className={style.label}>Endereço</label>
                    <input
                      type="text"
                      name="logradouroEnderecos"
                      placeholder="Endereço"
                      className={`${style.inputLikeText} ${style.desabilitar} ${modalEdicao ? style.inputHabilitado : ''}`}
                      value={dadosUsuario.logradouroEnderecos}
                      disabled={!modalEdicao}
                      readOnly
                      onChange={(e) =>
                        setDadosUsuario({
                          ...dadosUsuario,
                          logradouroEnderecos: e.target.value,

                        })
                      }
                    />
                  </div>
                </div>

                {/* Complemento  */}
                <div className={style.nome}>
                  <div>
                    <LuBuilding />
                  </div>
                  <div className={style.input_dados}>
                    <label className={style.label}>Complemento</label>
                    <input
                      maxLength={25}
                      type="text"
                      name="complementoEnderecos"
                      placeholder="Complemento"
                      className={`${style.inputLikeText} ${modalEdicao ? style.inputHabilitado : ''}`}
                      value={dadosUsuario.complementoEnderecos}
                      disabled={!modalEdicao}
                      onChange={(e) =>
                        setDadosUsuario({
                          ...dadosUsuario,
                          complementoEnderecos: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className={style.nome}>
                  <div>
                    <GrMapLocation />
                  </div>
                  <div className={style.input_dados}>
                    <label className={style.label}>Estado</label>

                    <input
                      type="text"
                      name="ufEnderecos"
                      placeholder="UF"
                      className={`${style.inputLikeText} ${style.desabilitar} ${modalEdicao ? style.inputHabilitado : ''}`}
                      value={dadosUsuario.ufEnderecos}
                      disabled={!modalEdicao}
                      readOnly
                      onChange={(e) =>
                        setDadosUsuario({
                          ...dadosUsuario,
                          ufEnderecos: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className={style.informacoes}>
                <div className={style.nome}>
                  <div>
                    <LuHouse />
                  </div>

                  <div className={style.input_dados}>
                    <label className={style.label}> Numero</label>
                    <input
                      maxLength={6}
                      type="text"
                      name="numeroEnderecos"
                      className={`${style.inputLikeText} ${modalEdicao ? style.inputHabilitado : ''}`}
                      placeholder="Número"
                      value={dadosUsuario.numeroEnderecos}
                      disabled={!modalEdicao}
                      onChange={(e) =>
                        setDadosUsuario({
                          ...dadosUsuario,
                          numeroEnderecos: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className={style.nome}>
                  <div>
                    <LuHouse />
                  </div>
                  <div className={style.input_dados}>
                    <label className={style.label}>Bairro</label>
                    <input
                      type="text"
                      name="bairroUsuarioEnderecos"
                      className={`${style.inputLikeText} ${style.desabilitar} ${modalEdicao ? style.inputHabilitado : ''}`}
                      placeholder="Bairro"
                      value={dadosUsuario.bairroUsuarioEnderecos}
                      disabled={!modalEdicao}
                      readOnly
                      onChange={(e) =>
                        setDadosUsuario({
                          ...dadosUsuario,
                          bairroUsuarioEnderecos: e.target.value,
                        })
                      }
                    />

                  </div>
                </div>

                <div className={style.nome}>
                  <div>
                    <LuMapPinHouse />
                  </div>

                  <div className={style.input_dados}>
                    <label className={style.label}>Cidade</label>
                    <input
                      type="text"
                      name="cidadeEnderecos"
                      placeholder="Cidade"
                      className={`${style.inputLikeText} ${style.desabilitar} ${modalEdicao ? style.inputHabilitado : ''}`}
                      value={dadosUsuario.cidadeEnderecos}
                      disabled={!modalEdicao}
                      readOnly
                      onChange={(e) =>
                        setDadosUsuario({
                          ...dadosUsuario,
                          cidadeEnderecos: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={style.botoes_Container}>
            <Button
              onClick={() => {
                if (modalEdicao) {
                  AtualizarPerfil();
                }
                setEdicao(!modalEdicao);
              }}
            >
              {modalEdicao ? "Salvar" : "Editar"}
            </Button>
            <Button
              className={style.botao}
              onClick={() => setMostrarModalEditar(true)}
            >
              Alterar Senha
            </Button>
          </div>
        </div>

        {/* Modal de edição de senha */}
        <Modal show={mostrarModalEditar} onHide={FecharModal}>
          <Modal.Header closeButton>
            <Modal.Title>Alterar Senha </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Senha Atual</Form.Label>
              <InputBuscar
                maxLength={100}
                type="password"
                placeholder="Digite sua senha atual"
                value={senhaAtual}
                onChange={(e) => setSenhaAtual(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Nova Senha</Form.Label>
              <InputBuscar
                maxLength={100}
                type="password"
                placeholder="Digite sua nova senha"
                value={senhaNova}
                onChange={(e) => setSenhaNova(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Confirmar Senha</Form.Label>
              <InputBuscar
                maxLength={100}
                type="password"
                placeholder="Confirme sua nova senha"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setMostrarModalEditar(false)}
            >
              Fechar
            </Button>
            <Button
              variant="primary"
              onClick={() =>
                AlterarSenhaUsuario(senhaAtual, senhaNova, confirmarSenha)
              }
            >
              Salvar Alterações
            </Button>
          </Modal.Footer>
        </Modal>


        {/* Modal de edição de Imagem */}
        <Modal className={style.modal_corpo} show={mostrarModalImagem} onHide={FecharModal}>
          <Modal.Header closeButton>
            <Modal.Title>Editar Imagem</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* Visualização da imagem atual */}
            <div className={style.foto_modal} >
              <Image
                src={foto || usuario}
                alt="Imagem do usuário"
                className={style.imgUsuario_modal}

              />
            </div>

            {/* Input para selecionar nova imagem */}
            <div style={{ marginTop: "20px", textAlign: "center" }}>
              <input
                type="file"
                accept="image/*"
                onChange={atualizarFoto}
                className={style.inputFile}
              />
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className={style.corpo_Icones}>
              <Button
                variant="primary"
                onClick={() => document.getElementById("fileInput")?.click()}

              >
                <MdEdit
                  className={style.editar}
                />

              </Button>
              <Button
                variant="danger"
                onClick={DeletarFotoUsuario}
              >
                <MdDelete

                  className={style.deletar}
                />

              </Button>

            </div>

          </Modal.Footer>
        </Modal>

      </Topbar>
    </Sidebar>
  );
}

export default DadosAlunos;

